export const lenisStore = { current: null };

export const scrollToHash = (hash) => {
  if (!hash) return;
  const el = document.getElementById(hash);
  if (!el) return;
  if (lenisStore.current) lenisStore.current.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const scrollTop = () => {
  if (lenisStore.current) lenisStore.current.scrollTo(0, { immediate: true });
  window.scrollTo(0, 0);
};
